export type ServiceIcon = 'scissors' | 'color' | 'treatment' | 'chemical' | 'extensions'

export type ServiceMeta = {
  id: string
  icon: ServiceIcon
  image: string
}

/** Same order as `services.categories` in each locale file (data/copy). */
export const serviceMeta: ServiceMeta[] = [
  {
    id: 'cortes',
    icon: 'scissors',
    image: 'https://cdn.magicpatterns.com/uploads/6pcBJkCzkNiaLrS1TTBBAB/cortes.png',
  },
  {
    id: 'color',
    icon: 'color',
    image: 'https://cdn.magicpatterns.com/uploads/hMa9hAPDnbyXCqdULuFuVw/servicio_de_color.png',
  },
  {
    id: 'tratamientos',
    icon: 'treatment',
    image: 'https://cdn.magicpatterns.com/uploads/sbyCZdYPvSa7JFkxY7keQL/tratamientos.png',
  },
  {
    id: 'extensiones',
    icon: 'extensions',
    image:
      'https://cdn.magicpatterns.com/uploads/ieQuvfxMkMFJ8jxhrU5j8z/extensiones_y_trenzas.png',
  },
]
